import allPoints from "../../../assets/images/all_points.svg";
import pulse from "../../../assets/images/pulse.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
import starNetwork from "../../../assets/images/star_network.svg";
import nyce from "../../../assets/images/nyce_network.svg";
import moneyPass from "../../../assets/images/money_pass.svg";

export const cardTechnology = [
  { label: "EMV Chip & PIN", value: 0 },
  { label: "Contactless EMV", value: 1 },
  { label: "Magstripe", value: 2 },
  { label: "Contactless Magstripe", value: 3 },
  { label: "Other", value: 4 },
];
export const tempCard = {
  cards: [
    {
      label: "Discover®",
      value: "Discover",
    },
    {
      label: "American Express®",
      value: "American Express",
    },
    {
      label: "UnionPay®",
      value: "UnionPay",
    },
    {
      label: "Closed Loop",
      value: "Closed Loop",
    },
  ],
  closedLoop: [
    {
      label: "Blackhawk Networks®",
      value: "Blackhawk Networks",
    },
    {
      label: "Others",
      value: "Others",
    },
  ],
};
export const atm_networks = [
  {
    label: "STAR® Network",
    value: 0,
    icon: starNetwork,
  },
  {
    label: "NYCE Network",
    value: 1,
    icon: nyce,
  },
  {
    label: "Money Pass",
    value: 2,
    icon: moneyPass,
  },
  {
    label: "All Point",
    value: 3,
    icon: allPoints,
  },
  {
    label: "PULSE",
    value: 4,
    icon: pulse,
  },
  {
    label: "Other",
    value: 5,
    icon: cardPlaceholder,
  },
];

export const subBin = [
  {
    value: "10",
    label: "10",
  },
  {
    value: "100",
    label: "100",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const cardInfo = [
  { label: "Sent via email", value: 0 },
  { label: "Displayed on the mobile app", value: 1 },
  { label: "Displayed on the cardholder website", value: 2 },
  { label: "I2c Hosted SDK", value: 3 },
  { label: "Other", value: 4 },
];
